<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('completeBuilding.managementRequests') }}</router-link> /
            <span class="color-main">{{ $t('completeBuilding.completeBuildingData') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('completeBuilding.subtitle') }}</p>
        </div>
      </div>
      <div class="white-box">
        <div class="main-title-box">{{ $t('completeBuilding.addBuilding') }}</div>
        <div class="main-body-box">
          <div class="col-md-8 col-12">
            <v-form @submit.prevent="addBuilding" v-model="valid" ref="form">
              <div class="main-input-cont mt-1 mb-4">
                <div class="flex-big-gap">
                  <div class="all-container-type">
                    <h6 class="mb-3">{{ $t('completeBuilding.buildingUse') }}</h6>
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        checked
                        name="use"
                        value="living"
                        v-model="checkUseModal"
                        @change="checkUse"
                        id="company"
                        class="mainRadio"
                      />
                      <label for="company" class="font14">{{ $t('completeBuilding.residential') }}</label>
                    </div>
                  </div>
                  <div class="all-container-type">
                    <h6 class="styleOnly mb-3">styleOnly</h6>
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        id="user"
                        @change="checkUse"
                        v-model="checkUseModal"
                        value="commercial"
                        name="use"
                        class="mainRadio"
                      />
                      <label for="user" class="font14">{{ $t('completeBuilding.commercial') }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('completeBuilding.buildingCode') }}</h6>
                <v-text-field
                  type="text"
                  name="ref_code"
                  :rules="defaultRoles"
                  :placeholder="$t('completeBuilding.buildingCodePlaceholder')"
                ></v-text-field>
              </div>

              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('completeBuilding.ownerRatio') }}</h6>
                <v-text-field
                  type="number"
                  name="ratio"
                  :rules="defaultRoles"
                  :placeholder="$t('completeBuilding.ownerRatioPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('completeBuilding.apartmentsCount') }}</h6>
                <v-text-field
                  type="number"
                  name="units_count"
                  :rules="defaultRoles"
                  :placeholder="$t('completeBuilding.apartmentsCountPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1" v-if="showCommercial">
                <h6 class="mb-2 font14">{{ $t('completeBuilding.shopsCount') }}</h6>
                <v-text-field
                  type="number"
                  name="shops_count"
                  :rules="defaultRoles"
                  :placeholder="$t('completeBuilding.shopsCountPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont">
                <div class="flex-big-gap no-align yes-wrap">
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('completeBuilding.managementContract') }}</div>
                    <uploadFileSingle
                      name="contract"
                      id="uploadbuildingpaper"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('completeBuilding.propertyDeed') }}</div>
                    <uploadFileSingle
                      name="instrument"
                      id="uploadbuildingpaper2"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('completeBuilding.constructionCertificate') }}</div>
                    <uploadFileSingle
                      name="construction_completion_certificate"
                      id="uploadbuildingpaper3"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('completeBuilding.civilDefenseCertificate') }}</div>
                    <uploadFileSingle
                      name="civil_defense_certificate"
                      id="uploadbuildingpaper4"
                    />
                  </div>
                </div>
              </div>

              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl mt-4 mb-3"
              >
                <div v-if="!disabled">{{ $t('completeBuilding.confirmAddBuilding') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('completeBuilding.confirming') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </v-form>
          </div>
        </div>
      </div>
    </div>
  </main>

  <!-- success modal  -->
  <Dialog v-model:visible="showSuccess" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-3 mt-2">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font18 mb-4">
        {{ $t('completeBuilding.dataCompletedSuccess') }}
      </h6>
      <div class="flex-group-me mb-2">
        <router-link :to="'/buildingDetails' + route.params.id" class="main-btn lg up"> {{ $t('completeBuilding.buildingDetails') }} </router-link>
        <router-link to="/dashboardHome" class="main-btn lg up trans">
          {{ $t('completeBuilding.home') }}
        </router-link>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import uploadFileSingle from "../components/dashboard/uploadFileSingle.vue";
import Dialog from "primevue/dialog";
import axios from "axios";
import { useI18n } from "vue-i18n";
const route = useRoute();
import { useRoute } from "vue-router";

import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();

import { ref, onMounted } from "vue";
const { t } = useI18n();

// reactive state
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return t('completeBuilding.fieldRequired');
  },
]);
const successImg = ref(require("../assets/imgs/check.png"));
const showSuccess = ref(false);
const showCommercial = ref(false);
const valid = ref(false);

const disabled = ref(false);
const form = ref(null);

const checkUseModal = ref("living");

// functions
function addBuildingSend() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);

  fd.append("building_id", route.params.id);

  axios
    .post("/manager/complete-building", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        showSuccess.value = true;
        setTimeout(function () {
          router.push(`/addTenant/${route.params.id}`);
        }, 1500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function checkUse() {
  if (checkUseModal.value == "commercial") {
    showCommercial.value = true;
  } else {
    showCommercial.value = false;
  }
}

// addBuilding
function addBuilding() {
  if (valid.value) {
    addBuildingSend();
  } else {
    scrollToDanger();
  }
}
// scroll to danger input
function scrollToDanger() {
  var element = document.querySelector(".v-input--error");
  if (element) {
    element.querySelector("input").focus();
  }
}

// lifecycle hooks
onMounted(() => {});
</script>
